var React = require('react');

function Shapeclock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0.5C12.4 0.5 16 4.1 16 8.5C16 12.9 12.4 16.5 8 16.5C3.6 16.5 0 12.9 0 8.5C0 4.1 3.6 0.5 8 0.5ZM8 2.1C4.48 2.1 1.6 4.98 1.6 8.5C1.6 12.02 4.48 14.9 8 14.9C11.52 14.9 14.4 12.02 14.4 8.5C14.4 4.98 11.52 2.1 8 2.1ZM7.9 4.5C8.17614 4.5 8.4 4.72386 8.4 5V8.3769C8.4 8.55254 8.49215 8.71529 8.64275 8.80565L11.5664 10.5598C11.8051 10.703 11.8809 11.0136 11.735 11.2506L11.622 11.4342C11.4773 11.6693 11.1693 11.7427 10.9342 11.598L7.43795 9.44643C7.29008 9.35543 7.2 9.19423 7.2 9.0206V5C7.2 4.72386 7.42386 4.5 7.7 4.5H7.9Z","fill":"black"}));
}

Shapeclock.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Shapeclock;

Shapeclock.default = Shapeclock;
